var map = {
	"./news.de-CH.json": 1397,
	"./news.de-DE.json": 1398,
	"./news.en-CA.json": 1399,
	"./news.en-GB.json": 1400,
	"./news.en-IN.json": 1401,
	"./news.en-ME.json": 1402,
	"./news.en-US.json": 1403,
	"./news.es-EM.json": 1404,
	"./news.es-ES.json": 1405,
	"./news.fr-BE.json": 1406,
	"./news.fr-CA.json": 1407,
	"./news.fr-CH.json": 1408,
	"./news.nl-BE.json": 1409,
	"./news.nl-NL.json": 1410,
	"./news.pl-PL.json": 1411,
	"./news.pt-BR.json": 1412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1396;